module.exports = __webpack_public_path__ + "static/media/logo-icon.f2403a7a.svg";